import { render, staticRenderFns } from "./WebshopDropdown.vue?vue&type=template&id=05eb43a2&scoped=true"
import script from "./WebshopDropdown.vue?vue&type=script&lang=js"
export * from "./WebshopDropdown.vue?vue&type=script&lang=js"
import style0 from "./WebshopDropdown.vue?vue&type=style&index=0&id=05eb43a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05eb43a2",
  null
  
)

export default component.exports